import { fetchWithToken, postWithToken } from "../authentication/AuthProvider";
import config, { apiUrl } from "../config";

const dpp = apiUrl + "/dpp";
const routes = {
  label: "DPP",
  root: dpp,
  get_published: dpp + "/get_published",
  update: dpp + "/update",
  new_pending: dpp + "/new_pending",
  new_published: dpp + "/new_published",
  publish: dpp + "/publish",
  get_pendings: dpp + "/get_pendings",
  get_mine_pending: dpp + "/get_mine_pending",
  get_mine_published: dpp + "/get_mine_published",
  get_mine_colleague_pending: dpp + "/get_mine_colleague_pending",
  get_mine_colleague_published: dpp + "/get_mine_colleague_published",
  get: dpp + "/get",
  get_published: dpp + "/get_published",
  get_photo: dpp + "/get_photo",
  save_photo: dpp + "/save_photo",
};

export const DPP = {
  new_published: (dpp, entityType = "product") => postWithToken(routes.new_published, { ...dpp, entity_type: entityType }),
  new_pending: (dpp, entityType = "product") => postWithToken(routes.new_pending, { ...dpp, entity_type: entityType }),

  get: (id) => postWithToken(routes.get, { id }),
  get_photo: (id) => postWithToken(routes.get_photo, { id }),
  get_published: (id, entityType = "product") => {
    const idKey = { project: "project_id", building: "building_id" }[entityType] || "product_id";
    return postWithToken(routes.get_published, { [idKey]: id, entity_type: entityType });
  },
  get_mine_published: () => postWithToken(routes.get_mine_published),
  get_mine_pending: () => postWithToken(routes.get_mine_pending),
  get_mine_colleague_published: () => postWithToken(routes.get_mine_colleague_published),
  get_mine_colleague_pending: () => postWithToken(routes.get_mine_colleague_pending),

  save_photo: (form) => fetchWithToken(routes.save_photo, { ...config.method.POST, body: form }),
  publish: (product_id, dpp_id) => postWithToken(routes.publish, { product_id, dpp_id }),
  update: (dpp) => postWithToken(routes.update, dpp),
};
